$(document).ready ->
  $ ->
    $('.sortable').railsSortable({ handle: '.handle' })
